import gql from 'graphql-tag'

export const DRIVER_SCORE_SETTING = gql`
  query DriverScoreSetting {
    driverScoreSetting {
      isSuccessful
      errorCode
      errorName
      message
      status
      driverScoreSetting {
        companyId
        effectiveDate
        minDistance
        percentageThreshold
        minScore
        costHarshAccel
        costHarshBrake
        costSharpturn
        costOverspeed
        costParkExceeded
        costIdleExceeded
        costYawn
        costDistraction
        costSmoking
        costPhoneCalling
        costEyeClosed
        costMissingFace
        scoreGrade {
          grade
          minimum
          maximum
        }
      }
    }
  }
`

export const UPDATE_DRIVER_SCORE_SETTING = gql`
  mutation UpdateDriverScoreSetting($input: UpdateDriverScoreSettingInput!) {
    updateDriverScoreSetting(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      updateDriverScoreSetting {
        effectiveDate
      }
    }
  }
`
